export class CostReviewElectricalSafety {
  customerSiteSafetyRequired!: number;
  safetyObserverRequired!: number;
  safetyObserverSuppliedBy!: number;
  outageRequired!: number;
  temporaryPowerRequired!: number;
  hazardousMaterialsPresent!: number;
}
